import Component from './component';

const FeaturedListings = (props) => <Component {...props} />;

export default FeaturedListings;

export { Component as component };
